import React, { useState } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import PageHeader from '@node-space/storybook-components/dist/PageHeader'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { Button, Icon } from '@node-space/ui-components'
import { useMerchantsQuery } from 'hooks/queries/useMerchantsQuery'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { ActionIds } from 'types/types'
import { MerchantSheet } from './MerchantSheet'

export const MerchantHeader = () => {
  const { t } = useTranslation()

  const { data: { merchantList = [] } = {} } = useMerchantsQuery()

  const [action, setAction] = useAtom(actionAtom)
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const permissions = useMappedRoles()?.manageMerchants

  const canEdit = permissions?.canEdit

  const handleOpenMerchantCreateSheet = () => {
    setAction({
      ...action,
      actionId: ActionIds.MERCHANT_CREATE,
      onClose: () => {
        setIsSheetOpen(false)
      },
      header: t('createMerchant'),
      meta: {
        merchant: null,
      },
    })
    setIsSheetOpen(true)
  }

  return (
    <>
      {!merchantList?.length ? (
        <StatusCard
          button={
            canEdit && {
              onClick: handleOpenMerchantCreateSheet,
              text: t('manageMerchants.emptyStateButtonText'),
            }
          }
          description={t('manageMerchants.emptyStateDescription')}
          headline={t('manageMerchants.emptyStateHeadline')}
        />
      ) : (
        <PageHeader
          description={t('tokenInfo')}
          {...(canEdit && {
            renderRightSection: (
              <Button onClick={handleOpenMerchantCreateSheet} iconElement={<Icon name="Plus" />}>
                {t('createMerchant')}
              </Button>
            ),
          })}
        />
      )}

      <MerchantSheet isSheetOpen={isSheetOpen} />
    </>
  )
}
